<script setup lang="ts">
</script>

<template>
  <div class="df fdc pt-1">
    <div class="df aic jcsb pointer center-text mb-2">
      <span class="weight--intermedium size--body">{{ $t('www.garantie.modal.title-v2') }}</span>
    </div>
    <div class="df aifs fdr md-fdc">
      <div class="fb33 df aic pe-n mb-2">
        <svg class="cicon cicon--24 mr-2 ml-2 pe-n">
          <use xlink:href="#auth"/>
        </svg>
        <div class="df fdc">
          <div class="size--body pe-n c-green-std">{{ $t('www.garantie.modal.one_v2') }}</div>
          <span class="size--headline pe-n">{{ $t('www.garantie.modal.one_body') }}</span>
        </div>
      </div>
      <div class="fb33 df aic pe-n mb-2">
        <svg class="cicon cicon--20  mr-2 ml-2 pe-n">
          <use xlink:href="#secure_payment_v2"/>
        </svg>
        <div class="df fdc">
          <span class="size--body pe-n c-green-std">{{ $t('www.garantie.modal.two_v2') }}</span>
          <span class="size--headline pe-n">{{ $t('www.garantie.modal.two_v2_body') }}</span>
        </div>
      </div>
      <div class="fb33 df aic pe-n mb-2">
        <svg class="cicon cicon--20 mr-2 ml-2 pe-n">
          <use xlink:href="#service_client"/>
        </svg>
        <div class="df fdc">
          <span class="size--body pe-n c-green-std">{{ $t('www.garantie.modal.three') }}</span>
          <span class="size--headline pe-n">{{ $t('www.garantie.modal.three_body') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
